import { render } from "./speakers.vue?vue&type=template&id=a72acd52&scoped=true"
import script from "./speakers.vue?vue&type=script&lang=js"
export * from "./speakers.vue?vue&type=script&lang=js"

import "./speakers.vue?vue&type=style&index=0&id=a72acd52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a72acd52"

export default script